export enum Language {
  EN = 'en',
  GA = 'ga',
}

export interface TranslationRecord {
  [Language.EN]: string;
  [Language.GA]: string;
}

export interface TranslationNestedRecord {
  [key: string]: TranslationRecord | TranslationNestedRecord;
}

export const isTranslationRecord = (
  record: TranslationRecord | TranslationNestedRecord,
): record is TranslationRecord => {
  const recordKeys = Object.keys(record);
  return LANGUAGES.some(languageCode => recordKeys.includes(languageCode));
};

export const areTranslationRecordsEqual = (
  a: TranslationRecord,
  b: TranslationRecord,
): boolean =>
  a[Language.EN] === b[Language.EN] && a[Language.GA] === b[Language.GA];

export const LANGUAGES = Object.values(Language);
